<template>
  <el-table :data="list" stripe style="width: 100%">
    <el-table-column label="Категория" min-width="300">
      <template slot-scope="scope">
        <span v-if="scope.row.category_name">{{ scope.row.category_name }}</span>
        <span v-else>—</span>
      </template>
    </el-table-column>
    <el-table-column label="Город" min-width="200">
      <template slot-scope="scope">
        <span v-if="scope.row.city_name">{{ scope.row.city_name }}</span>
        <span v-else>—</span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="Действия" width="120">
      <template slot-scope="scope">
        <el-button
          size="small"
          type="success"
          @click="onEdit(scope.row.id)"
        >
          <i class="far fa-edit" />
        </el-button>

        <el-button
          size="small"
          type="danger"
          @click="onDelete(scope.row.id)"
        >
          <i class="far fa-trash-alt" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'SeoTemplatesList',
  computed: {
    ...mapState('seoTemplates', {
      list: 'seoTemplatesList',
    }),
  },
  methods: {
    ...mapActions('seoTemplates', [
      'deleteSeoTemplate',
      'fetchSeoTemplatesList',
    ]),
    onEdit(id) {
      this.$router.push({name: 'UpdateSeoTemplate', params: {id}})
    },
    async onDelete(id) {
      try {
        const res = await this.$confirm('Вы действительно хотите удалить этот SEO шаблон?')
        if (res) {
          await this.deleteSeoTemplate(id)
          await this.fetchSeoTemplatesList()
          this.$message.success('SEO шаблон успешно удален')
        }
      } catch {
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.seo-templates-list__image
  max-width: 50px
  max-height: 50px
  object-fit: contain
</style>
